const CalendarEventSubscriptionState = {
  Confirmed: 'Confirmed',
  Rejected: 'Rejected',
  Maybe: 'Maybe',
  InvitedToJoin: 'InvitedToJoin',
  RequestedToJoin: 'RequestedToJoin',
};

export default CalendarEventSubscriptionState;
